import {LoadableView} from '../../state/views/types';
import {makeTrackEvent} from './makeTrackEvent';

export type NamedWorkspaceAction =
  | 'Delete view'
  | 'Save view'
  | 'New view'
  | 'Clear changes' // previously known as "Reset changes"
  | 'Save as new view'
  | 'Copy to personal workspace'
  | 'Reset workspace'
  | 'View'
  | 'Copy workspace url'
  | 'Undo'
  | 'Redo';
export type NamedWorkspaceLocation =
  | 'modal'
  | 'menu'
  | 'view bar'
  | 'page'
  | 'keyboard shortcut';
export type NamedWorkspaceType =
  | 'legacy shared'
  | 'legacy personal'
  | 'shared'
  | 'personal'
  | 'unknown';
export const trackNamedWorkspaces = makeTrackEvent<
  {
    action: NamedWorkspaceAction;
    location: NamedWorkspaceLocation;
    viewerIsUsingAdminPowers: boolean;
    viewType: LoadableView['type'] | undefined;
    viewName: string;
    workspaceType: NamedWorkspaceType;
  },
  {
    action: {
      description: 'what action clicked on';
      exampleValues: ['Clear changes', 'Save view', 'View'];
    };
    location: {
      description: 'where this action is located';
      exampleValues: ['modal', 'menu', 'view bar', 'page'];
    };
    viewerIsUsingAdminPowers: {
      description: 'if w&b admin has their powers toggle on';
      exampleValues: [true, false];
    };
    viewType: {
      description: 'the "type" field in the views table';
      exampleValues: ['project-view', 'sweep-view', 'run-view', 'group-view'];
    };
    viewName: {
      description: 'the "name" field in the views table';
      exampleValues: ['workspace', 'default', 'nw-nwuserjofang-w'];
    };
    workspaceType: {
      description: 'determines if the workspace user is currently viewing belongs to them or not';
      exampleValues: ['personal', 'unknown', 'shared'];
    };
    _description: 'Tracks events related to named workspaces';
    _location: 'multi-run, group, and sweep workspaces';
    _motivation: 'new UI added, track usage';
  }
>('Named workspaces');

export type WorkspaceErrorAction = 'View' | 'Reset workspace';
export type WorkspaceErrorType =
  | 'Error boundary'
  | 'Empty workspace'
  | 'Generic';
export const trackWorkspaceError = makeTrackEvent<
  {
    action: WorkspaceErrorAction;
    errorType: WorkspaceErrorType;
    viewerIsUsingAdminPowers: boolean;
    viewType: LoadableView['type'] | undefined;
    error?: any;
  },
  {
    action: {
      description: 'what action clicked on';
      exampleValues: ['View', 'Reset workspace'];
    };
    errorType: {
      description: 'if w&b admin has their powers toggle on';
      exampleValues: [];
    };
    viewerIsUsingAdminPowers: {
      description: 'if w&b admin has their powers toggle on';
      exampleValues: [true, false];
    };
    viewType: {
      description: 'the "type" field in the views table';
      exampleValues: ['project-view', 'sweep-view', 'run-view', 'group-view'];
    };
    error: {
      description: 'error that user hit';
      exampleValues: [{error: 'i am an error'}];
    };
    _description: 'Tracks errors displayed to users in workspaces';
    _location: 'multi-run, group, run, and sweep workspaces';
    _motivation: 'To understand what types of errors users often hit';
  }
>('Workspace Error');
